export class ThemeInjector {
  element?: HTMLElement;

  constructor(element?: HTMLElement) {
    this.element = element;
  }

  replace(element: Node) {
    this.element?.replaceWith(element);
    return element;
  }

  append(element: Node) {
    this.element?.append(element);
    return element;
  }

  prepend(element: Node) {
    this.element?.prepend(element);
    return element;
  }

  insertBefore(element: Node) {
    this.element?.before(element);
    return element;
  }

  insertAfter(element: Node) {
    this.element?.after(element);
    return element;
  }

  closest(selector: string | object, depth: number = 5) {
    if (!this.element) {
      return new ThemeInjector();
    }

    if (typeof selector === "object") {
      return this.searchByStyle(
        selector,
        this.element,
        (element) => element.parentElement,
        depth
      );
    }

    const element = this.element.closest(selector) as HTMLElement;
    if (element) {
      return new ThemeInjector(element);
    }

    return new ThemeInjector();
  }

  find(selector: string) {
    const element = this.element?.querySelector(selector) as HTMLElement;
    if (element) {
      return new ThemeInjector(element);
    }

    return new ThemeInjector();
  }

  searchByStyle(
    search: object,
    element: HTMLElement,
    next: (element: HTMLElement) => HTMLElement | null,
    depth: number = 5
  ): ThemeInjector | null {
    if (depth < 0 || !element) {
      return null;
    }

    const computedStyle = getComputedStyle(element);
    const isMatch = Object.entries(search).every(
      ([key, value]) => computedStyle.getPropertyValue(key) === value
    );

    if (isMatch) {
      return new ThemeInjector(element);
    }

    const nextElement = next(element);
    if (!nextElement) {
      return null;
    }

    return this.searchByStyle(search, nextElement, next, depth - 1);
  }
}
